$(function(){
    var dataTable = null;
    
    function reloadLicenseData(){
        $.displayLoadingIndicator(loadingText);
        $('#licenseTable').hide();  
        $('.pagination-controls').hide();
    	sessionStorage.license = $("#licenseSelect").val();

        getTableData();
    }
    
    function getLicenseData() {
    	return  $.ajax({
            url : 'settings/getCloudLicenseInfo',
            data : {},
            dataType: 'json',
            async : true,
            cache : false
    	});
    }
    
	function getTableData() {
        var tableSorting = [[1, 'asc'], [2, 'asc'], [3, 'asc']];
        var displayRecords = 25;
        
        $.when(
            getLicenseData()
        ).done(function(response) {
        	$.debugLog("Cloud License Information Table Data: ");
        	$.debugLog(response);
        	if (response.success) {
        		if ( !!dataTable ) {
        			$('#licenseTable').dataTable().fnClearTable();
        			$('#licenseTable').dataTable().fnAddData(response.licenseList);
        		} else {
	                dataTable = $('#licenseTable').dataTable({
	                    bProcessing: false,
	                    bAutoWidth : false,
	                    aaData: response.licenseList,
	                    aoColumns: [
	                        {
	                            mData : 'customer.name',
	                            sDefaultContent : ''
	                        },
	                        {
	                            mData : 'customer.number',
	                            sDefaultContent : ''
	                        },
	                        {
	                            mData : 'site.id',
	                            sDefaultContent : ''
	                        },
	                        {
	                            mData : 'product.name',
	                            sDefaultContent : ''
	                        },
	                        {
	                            mData : 'product.end',
	                            sDefaultContent : ''
	                        },
	                        {	
	                            mData : 'licenses.used',
	                            sDefaultContent : ''
	                        },
	                        {	
	                            mData : 'licenses.total',
	                            sDefaultContent : ''
	                        }
	                        
	                    ],
	                    "fnCreatedRow": function ( nRow, aData, iDataIndex ) {
	                    	// Check for after End Date
	                    	if( new Date(aData.product.end) < new Date()) {
	                    		$('td', nRow).eq(4).addClass('error');
	                    	}
	                    	// Check for no more Licenses
	                        if( aData.licenses.used >= aData.licenses.total ) {
	                            $('td', nRow).eq(5).addClass('error');
	                        }
	                    },
	                    "aaSorting" : tableSorting,
	                    "bPaginate" : true,
	                    "sPaginationType" : "full_numbers",
	                    "iDisplayLength" : displayRecords, 
	                    "bLengthChange" : true,
	                    "sDom" : 'Rt<"#licenseRowCount"l><"#licensePagination"p>',
	                    "oLanguage" : {
	                        "oPaginate" : {
	                            "sFirst" : firstPaginationText,
	                            "sPrevious" : previousPaginationText,
	                            "sNext" : nextPaginationText,
	                            "sLast" : lastPaginationText
	                        },
	                        "sLengthMenu": showLabelText + '<select>' +
	                        '<option value="10">' + count10Text + '</option>' +
	                        '<option value="25">' + count25Text + '</option>' +
	                        '<option value="50">' + count50Text + '</option>' +
	                        '<option value="100">' + count100Text + '</option>' +
	                        '<option value="500">' + count500Text + '</option>' +
	                        '<option value="-1">' + countAllText + '</option>' +
	                        '</select>' + entriesLabelText
	                    },
	                    "bStateSave" : true,                    
	                    "fnInitComplete" : function(settings, json) {
	                        // Position the pagination controls
	                        var rowCountWidget = $('#licenseRowCount');
	                        rowCountWidget.addClass('row-count');
	                        rowCountWidget.appendTo('.pagination-controls');
	                        
	                        var paginationWidget = $('#licensePagination');
	                        paginationWidget.addClass('pagination');
	                        paginationWidget.appendTo('.pagination-controls');
	                    }
	                });
        		}
        	} else {
        		$.removeLoadingIndicator();
                $.showMessageDialog({
                    dialogID : '#errorMsgDialog',
                    title    : licenseErrorTitle,
                    message  : response.message 
                });
        	}
        	
        	TERMIT = false;
        }).always(function() {
            $.removeLoadingIndicator();
            $('#licenseTable').show();
            $('.pagination-controls').show();
        });
	}
    
    $(document).ready(function() {
        $.getJSON('database/list', {
            requestType: 'list', 
            nocache: new Date().getTime()
        }, function(data) {
            // Did we get a successful return?
            if (data.success) {
            	
            } else {
                var mainContents = $('.main-contents');
                mainContents.addClass('no-db');
                mainContents.html(noDatabaseText);
            }
        });
        
        reloadLicenseData();
    });
});